import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./Home";
import Order from "./Order";
import Orders from "./Orders";
import ProductForm from "./ProductForm";
import Layout, { Main } from "../Layout";
import Profile from "./Profile";
import { useApi } from "../Api/ApiContext";
import { useAsync } from "react-use";
import { Col, Row, Spinner } from "reactstrap";
import useMeStore from "../store/MeStore";
import Products from "./Products";
import Error404 from "../Error/Error404";
import Balance from "./Balance";
import Payments from "./Payments";
import useCelebritiesStore from "../store/CelebritiesStore";

const Dashboard = () => {
  const { getMe, getOrdersByUser } = useApi();
  const { me, storeMe } = useMeStore();
  const { celebrities } = useCelebritiesStore();

  const {
    value: orders,
    error: ordersError,
    loading: ordersLoading,
  } = useAsync(() => getOrdersByUser());

  const { loading, error } = useAsync(
    () => getMe().then((res) => storeMe(res)),
    []
  );

  if (loading) {
    return (
      <Layout>
        <Main>
          <Row>
            <Col lg={2} className={"mx-auto text-center"}>
              <Spinner color={"danger"} />
            </Col>
          </Row>
        </Main>
      </Layout>
    );
  }

  if (error) {
    return <Navigate to="/auth/login" />;
  }

  return me ? (
    <Routes>
      <Route
        path=""
        element={
          <Home
            orders={orders}
            ordersLoading={ordersLoading}
            ordersError={ordersError}
            me={me}
          />
        }
      />
      <Route path="products" element={<Products products={me.products} />} />
      <Route path="profile" element={<Profile me={me} />} />
      <Route path="order" element={<Order user={me} />} />
      <Route
        path="orders"
        element={
          <Orders
            orders={orders}
            ordersLoading={ordersLoading}
            ordersError={ordersError}
          />
        }
      />
      <Route path={"product/new"} element={<ProductForm />} />
      <Route path={"product/update"} element={<ProductForm />} />
      <Route path={"balance"} element={<Balance />} />
      <Route path={"payments"} element={<Payments />} />
      <Route
        path={"*"}
        element={
          <Layout celebrities={celebrities.items}>
            <Error404 />
          </Layout>
        }
      />
    </Routes>
  ) : (
    <Navigate to="/auth/login" />
  );
};

export default Dashboard;
